// Copyright (C) 2021 TANNER AG

import React, { useEffect } from "react";
import { compose, withProps } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import withPageInfo from "../hocs/withPageInfo";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import Navigation from "../layouts/Navigation";
import EMobilityTopicIntro from "../emobility/EMobilityTopicIntro";
import ActionLink from "../emobility/ActionLink";
import EMobilityContent from "../emobility/EMobilityContent";
import Grid from "@material-ui/core/Grid";
import withTSTopic from "../hocs/withTSTopic";
import { useHashLink } from "../emobility/usehashscroll";
import SummaryBar from "../components/SummaryBar";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        paddingBottom: 32,
    },
    heading: {
        marginTop: 24,
        marginBottom: 32,
    },
});

const TransportSolutionsTopic = ({ classes, setPageInfo, tSTopic, location }) => {
    const executeHashScroll = useHashLink();

    useEffect(() => {
        if (location.hash) {
            executeHashScroll(location.hash.substring(1));
        }
    }, [location.hash]);

    useEffect(() => {
        setPageInfo({ parentTitle: tSTopic.title });
    }, []);

    return (
        <React.Fragment>
            <Navigation />
            <div className={classes.mainWrapperStyle}>
                <EMobilityTopicIntro
                    kicker="TRANSPORT SOLUTIONS"
                    title={tSTopic.title}
                    number={tSTopic.order}
                    description={tSTopic.intro}
                    image={tSTopic.thumbnail}
                >
                    {tSTopic.tsChapters &&
                        tSTopic.tsChapters.map((chapter) => {
                            const contentNumber = `${tSTopic.order}.${chapter.order}`;
                            return (
                                <ActionLink
                                    key={chapter.id}
                                    to={`${tSTopic.slug}/${chapter.slug}`}
                                    number={contentNumber}
                                >
                                    {chapter.title}
                                </ActionLink>
                            );
                        })}
                </EMobilityTopicIntro>
                <SummaryBar
                    sections={tSTopic.tsContents
                        .map((content, index) => ({ headline: content.title, slug: `chapter-${index}` }))
                        .filter((content) => content.headline)}
                    disabledMarker
                />
                <div className={classes.sectionsWrapperStyle}>
                    <div className={classes.containerStyle}>
                        <Grid container>
                            <Grid item xs md={8}>
                                <EMobilityContent eMobilityContents={tSTopic.tsContents} withNavBar />
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default compose(
    withProps(({ match: { params } }) => {
        return {
            slug: params.topicSlug,
        };
    }),
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    withErrorState,
    withTSTopic(),
    withPageInfo,
    withRouter,
    withStyles(sharedComponentStyles),
    withStyles(styles)
)(TransportSolutionsTopic);



// WEBPACK FOOTER //
// ./src/transportsolutions/TransportSolutionsTopic.js